
import { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import AfflilationOrderDetailsConfirmation from './AfflilationOrderDetailsConfirmation';
import AfflProceedDeclaration from './AfflProceedDeclaration';
import AfflProceedConfrmDetails from './AfflProceedConfrmDetails';
import { useSelector } from 'react-redux';
import { GetStatusFlags } from '../../../Reducers/AffiliationCommonservice';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import AfflProceedCourseCnfmOamdc from '../AfflOrdOamdcVerif2023Tabs/AfflProceedCourseCnfmOamdc';
import { ProgressBar } from 'react-bootstrap';
export default function AfflOrdVerif2021() {
    const location = useLocation();
    const { state } = location;
    const Type = state?.type;
    const instname = state?.instname;
    const clgcode = state?.collCode;
    const [progress, setProgress] = useState(0);
    const CollegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const acYear = sessionStorage.getItem('ac_year');
    const status = useSelector((state) => state?.commonMastersReducer?.Status?.statusFlags?.[0] || null);
    const AfflOrderDetailsConfirmed = status?.cdc_inst_details_confirmation;
    const CourseDetailsConfirmed = status?.cdc_course_details_confirmation;
    const UndertakingConfirmed = status?.cdc_dsk_undertaking;

    let activeTab = (AfflOrderDetailsConfirmed && CourseDetailsConfirmed && UndertakingConfirmed) ? 2 :
        (AfflOrderDetailsConfirmed && CourseDetailsConfirmed) ? 1 : 0;

    const [latestTab, setlatestTab] = useState(0);

    const [currentTab, setCurrentTab] = useState(latestTab);
    const [isFirstTabSubmitted, setIsFirstTabSubmitted] = useState(false);
    const [isSecondTabSubmitted, setIsSecondTabSubmitted] = useState(false);

    const handleTabClick = (index) => {
        console.log("index", index)
        if (index <= currentTab) {
            setCurrentTab(index);
        }
        else {
            if (index === 1) {
                if (AfflOrderDetailsConfirmed) {
                    setCurrentTab(1);
                } else {
                    Swal.fire('Please complete the Affiliation Order Details Confirmation first!');
                }
            } else if (index === 2) {
                if (AfflOrderDetailsConfirmed && CourseDetailsConfirmed) {
                    setCurrentTab(2);
                } else {
                    Swal.fire('Please complete the previous steps before proceeding!');
                }
            } else {
                Swal.fire('Please complete the previous steps!');
            }
        }
    };

    const handleNext = () => {
        console.log("ddd", currentTab)
        if (currentTab <= 2) {
            setCurrentTab(currentTab + 1);
            setlatestTab(currentTab + 1);

        };
    }



    useEffect(() => {
        GetStatusFlags(acYear, CollegeCode);
    }, [acYear, CollegeCode]);

    const calculateProgress = () => {
        let completedCount = 0;
        if (AfflOrderDetailsConfirmed || isFirstTabSubmitted) completedCount++;
        if (CourseDetailsConfirmed || isSecondTabSubmitted) completedCount++;
        if (UndertakingConfirmed) completedCount++;
        return (completedCount / 3) * 100;
    };

    useEffect(() => {
        setProgress(calculateProgress());
    }, [AfflOrderDetailsConfirmed, CourseDetailsConfirmed, UndertakingConfirmed, isFirstTabSubmitted, isSecondTabSubmitted]);
    const handlelastTab = () => {
        if (currentTab <= 2) {
            setCurrentTab(2);
            setlatestTab(2);

        }
    };
    let progressBarColor = 'lightgreen';
    if (progress === 100) {
        progressBarColor = 'green';
    } else if (progress >= 66) {
        progressBarColor = 'mediumseagreen';
    } else if (progress >= 33) {
        progressBarColor = 'yellowgreen';
    }
    const orderDetailsConfirm = (AfflOrderDetailsConfirmed && CourseDetailsConfirmed && UndertakingConfirmed) ? true : AfflOrderDetailsConfirmed === false
    const CourseDetailsConfirm = (AfflOrderDetailsConfirmed && CourseDetailsConfirmed && UndertakingConfirmed) ? true : !AfflOrderDetailsConfirmed || !isFirstTabSubmitted



    let now = progress?.toFixed(2);
    return (
        <>
            <ProgressBar style={{ height: "20px", fontSize: "18x" }}
                animated
                now={now}
                label={`${now}%`}
                className='inner-progress'
            />

            <pre></pre>
            <pre></pre>
            <Tabs forceRenderTabPanel={false} selectedIndex={currentTab} onSelect={handleTabClick}>
                <TabList className="tabs-container affl-tabcontainer">
                    <Tab className="tab" style={{ width: "33%" }}
                        disabled={orderDetailsConfirm}>
                        AFFILIATION ORDER - DETAILS CONFIRMATION
                    </Tab>
                    <Tab className="tab"
                        disabled={(CourseDetailsConfirm)}
                    >
                        Proceed to confirm Course Details
                    </Tab>
                    <Tab className="tab"
                        disabled={!UndertakingConfirmed || !isSecondTabSubmitted}>Proceed To Declaration</Tab>
                </TabList>

                <TabPanel>
                    <div className="tab-panel">
                        <AfflilationOrderDetailsConfirmation instname={instname} Type={Type} clgcode={clgcode} onNext={handleNext} currentTab={currentTab} setIsFirstTabSubmitted={setIsFirstTabSubmitted} status={AfflOrderDetailsConfirmed} />
                    </div>
                </TabPanel>

                <TabPanel>
                    {Type && Type === "OAMDC" && Type !== "NONOAMDC" ? (<>
                        <div className="tab-panel">
                            <AfflProceedCourseCnfmOamdc onNext={handleNext} setIsSecondTabSubmitted={setIsSecondTabSubmitted} />
                        </div>

                    </>) : (<>  <div className="tab-panel">
                        <AfflProceedConfrmDetails onNext={handleNext} setIsSecondTabSubmitted={setIsSecondTabSubmitted} />
                    </div></>)}

                </TabPanel>

                <TabPanel>
                    <div className="tab-panel">
                        <AfflProceedDeclaration onNext={handlelastTab} prograssvalue={setProgress} />
                    </div>
                </TabPanel>
            </Tabs>


        </>
    )
}
